import React from "react";
import logo from "../../../Assets/logo.png";
import phone from "../../../Assets/middlenavbar/phone-icon.png";
import mail from "../../../Assets/middlenavbar/mail-icon.png";
import globe from "../../../Assets/middlenavbar/globe-icon.png";
import { useNavigate } from "react-router-dom";

const MiddleNavbar = () => {
  const navigate = useNavigate();
  return (
    <div className="px-4 sm:px-6 md:px-10 w-full h-[80px] hidden md:flex justify-between items-center bg-[#fffcf6]">
      <div
        onClick={() => navigate("/")}
        className="flex gap-5 py-2 items-center cursor-pointer"
      >
        <img src={logo} alt="logo" className="h-16 w-16" />
        <div className="flex flex-col text-xl font-serif ">
          <span>Kalinga Bio Ferti Chem</span>
          <span>Private Limited</span>
        </div>
      </div>
      <div className="flex space-x-6 items-center">
        <div className="flex items-center gap-3">
          <img src={phone} alt="phone" className="h-8 w-8" />
          <div className="flex flex-col text-xs">
            <span className="font-bold text-[#232323]">+91 98539 32961</span>
            <span className="ml-1 text-[#8B8B8B]">Make A Call</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <img src={mail} alt="mail" className="h-8 w-8" />
          <div className="flex flex-col text-xs">
            <span className="font-bold text-[#232323]">
              support@kalingabio.com
            </span>
            <span className="text-[#8B8B8B]">Get A Estimate</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <img src={globe} alt="globe" className="h-8 w-8" />
          <div className="flex flex-col text-xs">
            <span className="font-bold text-[#232323]">Bhubaneswar, India</span>
            <span className="text-[#8B8B8B]">Visit Our Office</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiddleNavbar;
